import {ProductGroupResponse} from "../common/api/Models/ProductGroupResponse";
import {Product, ProductPrice, SupplierProductDetail} from "../common/Product";

export interface AdditionalProductDetails {
    sku: string;
    productGroup: string;
    ticketPrice: number;
    promoPrice: number;
    artist: string;
    format: string;
    supplierProductDetails: SupplierProductDetail[];
    hasLabel: boolean;
    ean13: string;
    description?: string;
    physicalStockOnHand: number;
    availableStockOnHand: number;
    stockOnOrder: number;
    stockOnCustomerOrder: number;
}

export function getAdditionalProductDetails(products: Product[], productGroups: ProductGroupResponse[], productPrices: ProductPrice[]): AdditionalProductDetails[] {
    const skuList = products.map((product) => product.id);
    return skuList.map((sku) => {
        const product = products.find((product) => product.id === sku);
        const productGroup = productGroups.find((productGroup) => productGroup.id === product?.productGroupId);
        const prices = productPrices.find(price => price.sku === sku);
        return {
            sku,
            productGroup: productGroup?.name ?? "",
            ticketPrice: prices?.ticketPrice ?? 0,
            promoPrice: prices?.promotionPrice ?? 0,
            artist: product?.artist ?? "",
            format: product?.format ?? "",
            supplierProductDetails: product?.supplierProductDetails ?? [],
            hasLabel: product?.hasLabel ?? false,
            ean13: product?.ean13 ?? "",
            description: product?.description,
            physicalStockOnHand: product?.physicalStockOnHand ?? 0,
            availableStockOnHand: product?.availableStockOnHand ?? 0,
            stockOnOrder: product?.stockOnOrder ?? 0,
            stockOnCustomerOrder: product?.stockOnCustomerOrder ?? 0,
        };
    });
}
